// extracted by mini-css-extract-plugin
export default {"statusText":"styles_statusText__QwiTn"};